<div class="filter-bar-container">
  <app-saved-filters-dropdown
    [reportSlug]="reportName"
    [canFilterByDistrict]="canFilterByDistrict">
  </app-saved-filters-dropdown>
  <div class="filters-wrapper">
    <div class="filters-label">Applied Filters:</div>
    <div class="filters-badges">
      <ng-container
        *ngIf="canFilterByDistrict && appliedFilters.districtFilter">
        <div
          class="badge badge-item"
          *ngFor="let district of appliedFilters.districtFilter">
          <span class="fw-800"><i class="bi bi-geo-alt"></i> District: </span
          >{{ district.title }}
          <i
            *ngIf="appliedFilters.districtFilter.length > 1"
            (click)="
              setReportName();
              filterService.removeFilterFromList({
                keyName: 'districtFilter',
                value: district
              })
            "
            class="bi bi-x"></i>
        </div>
      </ng-container>
      <ng-container *ngIf="reportName !== 'badge_progress'">
        <ng-container
          *ngIf="
            reportName !== 'credits_earned' || !appliedFilters.dateRangeFilter
          ">
          <ng-container
            *ngIf="
              reportName === 'badges_earned_growth' &&
              appliedFilters.schoolYearsFilter
            ">
            <div
              class="badge badge-item"
              *ngFor="let year of appliedFilters.schoolYearsFilter">
              <span class="fw-800"
                ><i class="bi bi-calendar"></i> School Year: </span
              >{{ year.name }}
              <i
                class="bi bi-x"
                *ngIf="appliedFilters.schoolYearsFilter.length > 1"
                (click)="
                  setReportName();
                  filterService.removeFilterFromList({
                    keyName: 'schoolYearsFilter',
                    value: year
                  })
                "></i>
            </div>
          </ng-container>
          <ng-container *ngIf="appliedFilters.schoolYearFilter">
            <div class="badge badge-item">
              <span class="fw-800"
                ><i class="bi bi-calendar"></i> School Year: </span
              >{{ appliedFilters.schoolYearFilter.name }}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <div
        *ngIf="
          appliedFilters.topicFilter &&
          (reportName === 'badge_progress' ||
            reportName === 'evidence_report' ||
            reportName === 'badges_earned_growth')
        "
        class="badge badge-item removable">
        <span class="fw-800"><i class="bi bi-calendar"></i> Topic: </span
        >{{ appliedFilters.topicFilter.title }}
        <i
          class="bi bi-x"
          (click)="
            setReportName(); filterService.removeFilter('topicFilter')
          "></i>
      </div>
      <ng-container *ngIf="appliedFilters.schoolFilter">
        <div
          class="badge badge-item removable"
          *ngIf="this.filterService.viewingAllSchools"
          (click)="setReportName(); showModal = true">
          <span class="fw-800"><i class="bi bi-building"></i> School: </span>
          All Assigned Schools
        </div>
        <ng-container *ngIf="!this.filterService.viewingAllSchools">
          <div
            class="badge badge-item removable"
            *ngFor="let school of appliedFilters.schoolFilter">
            <span class="fw-800"><i class="bi bi-building"></i> School: </span>
            {{ school.title }}
            <i
              class="bi bi-x"
              *ngIf="!filterService.viewingAllSchools"
              (click)="
                setReportName();
                filterService.removeFilterFromList({
                  keyName: 'schoolFilter',
                  value: school
                })
              "></i>
          </div>
        </ng-container>
      </ng-container>
      <ng-container
        *ngIf="
          appliedFilters.hasOption !== undefined &&
          appliedFilters.hasOption !== null &&
          reportName === 'evidence_report'
        ">
        <div class="badge badge-item removable">
          <span class="fw-800"
            ><i class="bi bi-journal"></i> Attached to Option:
          </span>
          {{ appliedFilters.hasOption ? "Yes" : "No" }}
          <i
            (click)="setReportName(); filterService.removeFilter('hasOption')"
            class="bi bi-x"></i>
        </div>
      </ng-container>
      <ng-container
        *ngIf="
          appliedFilters.isReviewed !== undefined &&
          appliedFilters.isReviewed !== null &&
          reportName === 'evidence_report'
        ">
        <div class="badge badge-item removable">
          <span class="fw-800"
            ><i class="bi bi-clipboard-check"></i> Reviewed Status:
          </span>
          {{ appliedFilters.isReviewed ? "Reviewed" : "Not Reviewed" }}
          <i
            (click)="setReportName(); filterService.removeFilter('isReviewed')"
            class="bi bi-x"></i>
        </div>
      </ng-container>
      <ng-container *ngIf="appliedFilters.formAnswersFilter">
        <div
          class="badge badge-item removable"
          *ngFor="let formAnswer of appliedFilters.formAnswersFilter">
          <span class="fw-800"
            ><i class="bi bi-journal-text"></i> Form Answer:
          </span>
          {{ formAnswer.title }}
          <i
            (click)="
              setReportName();
              filterService.removeFilterFromList({
                keyName: 'formAnswersFilter',
                value: formAnswer
              })
            "
            class="bi bi-x"></i>
        </div>
      </ng-container>
      <ng-container *ngIf="appliedFilters.logTypeFilter">
        <div
          class="badge badge-item removable"
          *ngFor="let logType of appliedFilters.logTypeFilter">
          <span class="fw-800"
            ><i class="bi bi-journal"></i> Session Type:
          </span>
          {{ logType.title }}
          <i
            (click)="
              setReportName();
              filterService.removeFilterFromList({
                keyName: 'logTypeFilter',
                value: logType
              })
            "
            class="bi bi-x"></i>
        </div>
      </ng-container>

      <ng-container
        *ngIf="
          reportName === 'credits_earned' ||
          reportName === 'pd_session_summary' ||
          reportName === 'proforms_reports'
        ">
        <div
          class="badge badge-item removable"
          *ngFor="let type of appliedFilters.typesFilter">
          <span class="fw-800"><i class="bi bi-journal"></i> Event Type: </span>
          {{ type }}
          <i
            (click)="
              setReportName();
              filterService.removeFilterFromList({
                keyName: 'typesFilter',
                value: type
              })
            "
            class="bi bi-x"></i>
        </div>

        <ng-container *ngIf="reportName === 'pd_session_summary'">
          <div
            class="badge badge-item removable"
            *ngIf="appliedFilters.keyword">
            <span class="fw-800"><i class="bi bi-journal"></i> Keyword: </span>
            {{ appliedFilters.keyword }}
            <i
              (click)="
                setReportName();
                filterService.removeFilterFromList({
                  keyName: 'keyword',
                  value: '1'
                })
              "
              class="bi bi-x"></i>
          </div>

          <div
            class="badge badge-item removable"
            *ngIf="appliedFilters.virtualFilter">
            <span class="fw-800"><i class="bi bi-journal"></i> Format: </span>
            {{ appliedFilters.virtualFilter ? "Virtual" : "On-Site" }}
            <i
              (click)="
                setReportName();
                filterService.removeFilterFromList({
                  keyName: 'virtualFilter',
                  value: 1
                })
              "
              class="bi bi-x"></i>
          </div>

          <div
            class="badge badge-item removable"
            *ngIf="appliedFilters.completedFilter !== undefined">
            <span class="fw-800"
              ><i class="bi bi-journal"></i> Event Status:
            </span>
            {{ appliedFilters.completedFilter ? "Completed" : "Not Completed" }}
            <i
              (click)="
                setReportName();
                filterService.removeFilterFromList({
                  keyName: 'completedFilter',
                  value: '1'
                })
              "
              class="bi bi-x"></i>
          </div>
        </ng-container>

        <div
          *ngFor="let category of appliedFilters.categories; index as i"
          class="badge badge-item me-1 removable"
          (click)="
            setReportName();
            filterService.removeFilterFromList({
              keyName: 'categories',
              value: category,
              index: i
            })
          ">
          <span class="fw-800"> Category: </span>
          {{ category }}:
          {{
            appliedFilters !== undefined &&
            appliedFilters.category_options !== undefined &&
            appliedFilters.category_options[i] !== undefined
              ? appliedFilters.category_options[i]
              : ""
          }}
          &nbsp;<i class="bi bi-x"></i>
        </div>

        <ng-container *ngFor="let facilitator of appliedFilters.facilitators">
          <div
            class="badge badge-item removable"
            (click)="
              filterService.removeFilterFromList({
                keyName: 'facilitatorList',
                value: facilitator
              })
            ">
            <span class="fw-800"
              ><i class="bi bi-bi-person"></i> Facilitator:
            </span>
            {{ facilitator.profile.first_name }}
            {{ facilitator.profile.last_name }} &nbsp;<i class="bi bi-x"></i>
          </div>
        </ng-container>

        <ng-container *ngFor="let participant of appliedFilters.participants">
          <div
            class="badge badge-item removable"
            (click)="
              setReportName();
              filterService.removeFilterFromList({
                keyName: 'participantList',
                value: participant
              })
            ">
            <span class="fw-800"
              ><i class="bi bi-bi-person"></i> Participant:
            </span>
            {{ participant.profile.first_name }}
            {{ participant.profile.last_name }} &nbsp;<i class="bi bi-x"></i>
          </div>
        </ng-container>

        <ng-container *ngFor="let competency of appliedFilters.competencyList">
          <div
            class="badge badge-item removable"
            (click)="
              filterService.removeFilterFromList({
                keyName: 'competencyList',
                value: competency
              })
            ">
            <span class="fw-800"
              ><i class="bi bi-bi-person"></i> Competency:
            </span>
            <app-competency-name [competencyId]="competency.id" />&nbsp;
            <i class="bi bi-x"></i>
          </div>
        </ng-container>

        <ng-container *ngFor="let event of appliedFilters.eventFilter">
          <div
            class="badge badge-item removable"
            (click)="
              filterService.removeFilterFromList({
                keyName: 'eventList',
                value: event
              })
            ">
            <span class="fw-800"><i class="bi bi-bi-person"></i> Event: </span>
            {{ event.title }} &nbsp;
            <i class="bi bi-x"></i>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngFor="let sessionOwner of appliedFilters.sessionOwners">
        <div
          class="badge badge-item removable"
          (click)="
            filterService.removeFilterFromList({
              keyName: 'sessionOwnerList',
              value: sessionOwner
            })
          ">
          <span class="fw-800"
            ><i class="bi bi-bi-person"></i> Session Owner:
          </span>
          {{ sessionOwner.profile.first_name }}
          {{ sessionOwner.profile.last_name }} &nbsp;<i class="bi bi-x"></i>
        </div>
      </ng-container>

      <ng-container *ngIf="appliedFilters.cohortFilter">
        <div
          *ngFor="let cohort of appliedFilters.cohortFilter"
          class="badge badge-item removable">
          <span class="fw-800"><i class="bi bi-people"></i> Cohort: </span
          >{{ cohort.name }}
          <i
            class="bi bi-x"
            (click)="
              setReportName();
              filterService.removeFilterFromList({
                keyName: 'cohortFilter',
                value: cohort
              })
            "></i>
        </div>
      </ng-container>
      <div
        *ngIf="appliedFilters.assignedCoachFilter"
        class="badge badge-item removable">
        <span class="fw-800"><i class="bi bi-person"></i> Coach: </span
        >{{ appliedFilters.assignedCoachFilter.profile.first_name }}
        {{ appliedFilters.assignedCoachFilter.profile.last_name }}
        <i
          class="bi bi-x"
          (click)="
            setReportName(); filterService.removeFilter('assignedCoachFilter')
          "></i>
      </div>
      <div
        *ngIf="appliedFilters.dateRangeFilter"
        class="badge badge-item removable">
        <span class="fw-800"><i class="bi bi-calendar2-week"></i> Dates: </span
        >{{ appliedFilters.dateRangeFilter[0] | formatNgbDate }} -
        {{ appliedFilters.dateRangeFilter[1] | formatNgbDate }}
        <i
          class="bi bi-x"
          (click)="
            setReportName(); filterService.removeFilter('dateRangeFilter')
          "></i>
      </div>
      <ng-container *ngIf="appliedFilters.coacheesFilter">
        <div
          class="badge badge-item removable"
          *ngFor="let coachee of appliedFilters.coacheesFilter">
          <span class="fw-800"><i class="bi bi-journal"></i> Coachee: </span>
          {{ coachee.profile.first_name }} {{ coachee.profile.last_name }}
          <i
            (click)="
              setReportName();
              filterService.removeFilterFromList({
                keyName: 'coacheesFilter',
                value: coachee
              })
            "
            class="bi bi-x"></i>
        </div>
      </ng-container>
      <ng-container *ngIf="appliedFilters.planUserFilter">
        <div
          class="badge badge-item removable"
          *ngFor="let planUser of appliedFilters.planUserFilter">
          <span class="fw-800"><i class="bi bi-person"></i> Plan User: </span>
          {{ planUser.profile.first_name }} {{ planUser.profile.last_name }}
          <i
            (click)="
              setReportName();
              filterService.removeFilterFromList({
                keyName: 'planUserFilter',
                value: planUser
              })
            "
            class="bi bi-x"></i>
        </div>
      </ng-container>
    </div>
    <div class="edit-filters">
      <button
        type="button"
        class="btn btn-link text-nowrap"
        (click)="setReportName(); showModal = true">
        Edit Filters
      </button>
      <app-report-filter-modal
        (modalClosing)="showModal = false"
        [showModal]="showModal"
        [canFilterByDistrict]="canFilterByDistrict"
        [reportName]="reportName"
        [isAnonymous]="isAnonymous"
        #modal></app-report-filter-modal>
    </div>
  </div>
</div>
